import { createSelector } from '@ngrx/store';

import * as fromAuth from '../reducers/auth.reducers'
import * as fromRoot from '../reducers'


export const selectLoggedIn = createSelector(fromRoot.selectAuthState, fromAuth.getLoggedIn);
export const selectLoggedInUser = createSelector(fromRoot.selectAuthState, fromAuth.getLoggedInUser);
export const selectLoggedInUserPermissions = createSelector(fromRoot.selectAuthState, fromAuth.getLoggedInUserPermissions);
export const selectLoggedInUserRoles = createSelector(fromRoot.selectAuthState, fromAuth.getLoggedInUserRoles);



// WEBPACK FOOTER //
// ./src/app/core/store/selectors/auth.selectors.ts